var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9V1.5L11.3565 2.45265C10.91 2.6511 10.6868 2.75032 10.46 2.76854C10.2594 2.78465 10.0579 2.75518 9.87033 2.68232C9.65823 2.59991 9.47274 2.44092 9.10175 2.12293L8.88836 1.94002C8.39559 1.51765 8.14921 1.30646 7.87289 1.22598C7.62936 1.15504 7.37064 1.15504 7.12711 1.22598C6.85079 1.30646 6.60441 1.51765 6.11164 1.94002L5.89825 2.12293C5.52726 2.44092 5.34177 2.59991 5.12967 2.68232C4.94215 2.75518 4.74056 2.78465 4.54003 2.76854C4.31322 2.75032 4.08997 2.6511 3.64346 2.45265L1.5 1.5V12.2333C1.5 13.7268 1.5 14.4735 1.79065 15.044C2.04631 15.5457 2.45426 15.9537 2.95603 16.2094C3.52646 16.5 4.27319 16.5 5.76667 16.5H15M13.5 9H14.3667C15.1134 9 15.4868 9 15.772 9.14532C16.0229 9.27316 16.2268 9.47713 16.3547 9.72801C16.5 10.0132 16.5 10.3866 16.5 11.1333V15C16.5 15.8284 15.8284 16.5 15 16.5V16.5C14.1716 16.5 13.5 15.8284 13.5 15V9ZM9 7.5H7.5M7.5 7.5H7.125C6.50368 7.5 6 8.00368 6 8.625C6 9.24632 6.50368 9.75 7.125 9.75H7.875C8.49632 9.75 9 10.2537 9 10.875C9 11.4963 8.49632 12 7.875 12H7.5M7.5 7.5V6.75M7.5 12H6M7.5 12V12.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.784231a8e4395c3deea6f5ba7f79cccb.svg";
export { ForwardRef as ReactComponent };